import {useGetRelatedAccounts} from '../graphql/hooks/use-get-related-accounts';

export function useGetRelatedAccountsCount(contactId: string): string | undefined {
    const {accounts} = useGetRelatedAccounts(contactId, false, false, null, null);

    return accounts && accounts.totalCount ? `${accounts.totalCount}` : undefined;
}
